export default __webpack_public_path__ + "static/media/mypic.91c8a9ff.JPG";